// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sign_in_section {
    width: 352px;
    background-color: var(--color-bg-2);
    border: 1px solid var(--color-border);
    padding: 26px;
}

.sign_in_section__form {
    display: flex;
    flex-direction: column;
    gap: 13px;
}

.sign_in_section__input {
    width: 100%;
    padding: 7px 9px;
    background-color: var(--color-input-bg);
    border: 1px solid var(--color-input-border);
    color: var(--color-text);
    outline: none;
    font-size: 14px;
}

.sign_in_section__input:focus {
    border-color: var(--color-input-border-focus);
}

.sign_in_section__input:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.sign_in_section__input::placeholder {
    color: var(--color-text-muted);
}

.sign_in_section__error {
    color: var(--color-error);
    font-size: 13px;
}

.sign_in_section__button {
    width: 100%;
    padding: 7px 13px;
    background-color: var(--color-accent);
    color: #ffffff;
    border: none;
    font-size: 14px;
    cursor: pointer;
}

@media (pointer: fine) {
    .sign_in_section__button:hover:not(:disabled) {
        background-color: var(--color-accent-hover);
    }
}

.sign_in_section__button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./components/sections/SignInSection/s.sign_in_section.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,mCAAmC;IACnC,qCAAqC;IACrC,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,uCAAuC;IACvC,2CAA2C;IAC3C,wBAAwB;IACxB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,qCAAqC;IACrC,cAAc;IACd,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI;QACI,2CAA2C;IAC/C;AACJ;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB","sourcesContent":[".sign_in_section {\n    width: 352px;\n    background-color: var(--color-bg-2);\n    border: 1px solid var(--color-border);\n    padding: 26px;\n}\n\n.sign_in_section__form {\n    display: flex;\n    flex-direction: column;\n    gap: 13px;\n}\n\n.sign_in_section__input {\n    width: 100%;\n    padding: 7px 9px;\n    background-color: var(--color-input-bg);\n    border: 1px solid var(--color-input-border);\n    color: var(--color-text);\n    outline: none;\n    font-size: 14px;\n}\n\n.sign_in_section__input:focus {\n    border-color: var(--color-input-border-focus);\n}\n\n.sign_in_section__input:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.sign_in_section__input::placeholder {\n    color: var(--color-text-muted);\n}\n\n.sign_in_section__error {\n    color: var(--color-error);\n    font-size: 13px;\n}\n\n.sign_in_section__button {\n    width: 100%;\n    padding: 7px 13px;\n    background-color: var(--color-accent);\n    color: #ffffff;\n    border: none;\n    font-size: 14px;\n    cursor: pointer;\n}\n\n@media (pointer: fine) {\n    .sign_in_section__button:hover:not(:disabled) {\n        background-color: var(--color-accent-hover);\n    }\n}\n\n.sign_in_section__button:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
